module.exports = __webpack_public_path__ + "_assets/img/_b1-1-img.92e32b5e.png";